/**
 * Cashier deposit state for a freespin. The cashier (BonusesProvider.freeSpinAsBonus)
 * reads location.state.depositFreeSpin and picks the min deposit by wallet currency.
 * The generic preselectBonus does NOT preselect freespins, so both the bonus detail
 * page (useBonusActions) and the list card (BonusList) push this shape instead.
 * `row` is the mapped freespin (mapFreeSpinForUi shape).
 */
export const buildFreeSpinDepositState = row => ({
  depositFreeSpin: {
    bonusId: row.bonusId ?? null,
    bonusInstanceId: row.id,
    freeSpin: {
      currency: row.currency,
      expirationTime: row.expirationTime,
      freeSpin: {
        freeSpinMinAmountsDeposit: row.freeSpinMinAmountsDeposit,
        localizedImageInfoList: row.freeSpin?.localizedImageInfoList,
        localizedInfoList: row.freeSpin?.localizedInfoList,
      },
    },
    freeSpinSubType: row.freeSpinSubType,
  },
});
